export interface EmailSubscribe {
  address?: string;
  isConfirmed: boolean;
  isSubscribed?: boolean;
}
